import * as Yup from "yup"

export const SDSuppliersInitialValues = {
	name: "",
	isEnabled: true,
	payCode: "",
}

export const SDSuppliersSchema = Yup.object().shape({
	name: Yup.string().required().label("Name").trim(),
	isEnabled: Yup.boolean().label("Enabled"),
	company: Yup.string().required().label("Organization"),
	payCode: Yup.string().nullable().label("PayCode"),
})
